import React from 'react';

import moment from 'moment';

import { UiButton } from '../../ui/ui-button';

type InputProps = {
  message: Message;
};

export const ImageFromMessage = ({ message }: InputProps) => {
  const handleDownloadImage = (imageUrl: string) => () => {
    window.open(imageUrl, '_blank');
  };

  return (
    <>
      {message.imageUrls.split(',').map((imageUrl) => (
        <div
          key={imageUrl}
          className="u-spread u-padding-y"
          style={{ borderTop: '1px solid #e0e0e0' }}
        >
          <div>
            <img src={imageUrl} alt="Sent by text" className="u-maxWidth-400px" />
            <div className="typo-subtitle">
              {moment(message.activity.datetime).format('[Received on] dddd, MMMM Do [at] h:mma')}
            </div>
          </div>
          <UiButton size="xs" variant="tertiary" onClick={handleDownloadImage(imageUrl)}>
            Download
          </UiButton>
        </div>
      ))}
    </>
  );
};
